import {
  EmployeeActions,
  ProfileCompletionActions,
  RecommendedVideoActions,
  ManageSkillsActions,
  CareerPreferenceActions,
  WorkHistoryActions,
  EducationActions,
  SuccessProfileTopCategoriesActions,
  MarkFieldAsReadActions,
  ManageCompetenciesActions,
  SuccessProfileActions,
  OnboardEmployeeRolesAction,
  OnboardEmployeeOpenToWorkAction,
} from 'modules/profile/stateManagement/actions';
import * as constants from 'modules/profile/stateManagement/constants';
import {
  IEmployeeState,
  EMPLOYEE_INITIAL_STATE,
  IVideoState,
  RECOMMENDED_VIDEO_INITIAL_STATE,
  IProfileCompletionState,
  PROFILE_COMPLETION_INITIAL_STATE,
  UploadResumeSteps,
  IManageSkillsState,
  MANAGE_SKILLS_INITIAL_STATE,
  ICareerPreferencesState,
  CAREER_PREFERENCES_INITIAL_STATE,
  IWorkHistoryState,
  WORK_HISTORY_INITIAL_STATE,
  IEducationState,
  EDUCATION_INITIAL_STATE,
  ISuccessProfileTopCategoriesState,
  SUCCESS_PROFILE_INITIAL_STATE,
  IMarkedAsReadFieldsState,
  MARKED_FIELDS_INITIAL_STATE,
  IManageCompetenciesState,
  ISuccessProfileState,
  SUCCESS_PROFILE_TOP_CATEGORIES_INITIAL_STATE,
  IOnboardEmployeeSkillsState,
  ONBOARD_EMPLOYEE_SKILLS_INITIAL_STATE,
  ONBOARD_EMPLOYEE_ROLES_INITIAL_STATE,
  IOnboardEmployeeRolesState,
  IOnboardEmployeeOpenToWorkState,
  ONBOARD_EMPLOYEE_OPEN_TO_WORK_INITIAL_STATE,
  MANAGE_COMPETENCIES_INITIAL_STATE,
} from 'modules/profile/stateManagement/state';
import i18n from 'i18next';
import { AnalizedResumeStatus } from '../models/IProfile.interface';

export function employee(
  state: IEmployeeState = EMPLOYEE_INITIAL_STATE,
  action: EmployeeActions
): IEmployeeState {
  switch (action.type) {
    case constants.GET_EMPLOYEE_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_EMPLOYEE_SUCCESS: {
      return {
        ...state,
        employee: action?.payload?.employee,
        employeeProfileFlags: action?.payload?.employeeProfileFlags,
        isFetchingData: false,
      };
    }
    case constants.GET_EMPLOYEE_FAILED: {
      return {
        ...state,
        error: `${i18n.t('failToLoadProfile')}: ${action.payload}`,
        isFetchingData: false,
      };
    }
    case constants.EMPLOYEE_SKILLS_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              skills: {
                ...state.employee.skills,
                mySkills: action.payload,
              },
            }
          : null,
      };
    }
    case constants.EMPLOYEE_FOCUS_SKILLS_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              skills: {
                ...state.employee.skills,
                focusSkills: action.payload,
              },
            }
          : null,
      };
    }
    case constants.EMPLOYEE_WORK_HISTORY_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              workExperiences: action.payload,
            }
          : null,
      };
    }
    case constants.EMPLOYEE_EDUCATION_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              degreesAndCertifications: action.payload,
            }
          : null,
      };
    }
    case constants.EMPLOYEE_OPEN_TO_WORK_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              currentRole: {
                ...state.employee.currentRole,
                openToWork: action.payload,
              },
            }
          : null,
      };
    }
    case constants.EMPLOYEE_OPEN_TO_WORK_REMOTE_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              currentRole: {
                ...state.employee.currentRole,
                workRemote: action.payload,
              },
            }
          : null,
      };
    }
    case constants.EMPLOYEE_LOCATIONS_INTERESTED_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              currentRole: {
                ...state.employee.currentRole,
                locationsInterested: action.payload,
              },
            }
          : null,
      };
    }
    case constants.EMPLOYEE_INTERESTED_ROLES_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              interestedRoles: action.payload,
            }
          : null,
      };
    }
    case constants.EMPLOYEE_PROFILE_COMPLETENESS_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              profileCompleteness: action.payload,
            }
          : null,
      };
    }
    case constants.EMPLOYEE_RESUME_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              degreesAndCertifications:
                state.employee.degreesAndCertifications.concat(
                  action.payload.degreesAndCertifications
                ),
              workExperiences: state.employee.workExperiences.concat(
                action.payload.workExperiences
              ),
              skills: {
                ...state.employee.skills,
                mySkills: state.employee.skills.mySkills.concat(
                  action.payload.skills
                ),
              },
            }
          : null,
      };
    }
    case constants.EMPLOYEE_COMPETENCIES_UPDATED: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              competencies: action.payload,
            }
          : null,
      };
    }
    case constants.GET_PROFILE_COMPLETENESS_STARTED: {
      return { ...state, isLoadingProfileCompleteness: true };
    }
    case constants.GET_PROFILE_COMPLETENESS_SUCCESS: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              profileCompleteness: action.payload,
            }
          : null,
        isLoadingProfileCompleteness: false,
      };
    }
    case constants.GET_PROFILE_COMPLETENESS_FAILED: {
      return { ...state, isLoadingProfileCompleteness: false };
    }
    case constants.EMPLOYEE_GET_PROFILE_IMAGE_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.EMPLOYEE_GET_PROFILE_IMAGE_SUCCESS: {
      return {
        ...state,
        employee: state.employee
          ? {
              ...state.employee,
              profile: {
                ...state.employee.profile,
                profilePictureUrl: {
                  content: action.payload,
                },
              },
            }
          : null,
        isFetchingData: false,
      };
    }
    case constants.EMPLOYEE_GET_PROFILE_IMAGE_FAILED: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.TUAY_SKIP_UPDATED: {
      return {
        ...state,
        employeeProfileFlags: {
          ...state?.employeeProfileFlags,
          assessmentFlags: {
            ...state?.employeeProfileFlags?.assessmentFlags,
            tellUsAboutYourself: {
              ...state?.employeeProfileFlags?.assessmentFlags
                ?.tellUsAboutYourself,
              isSkipped: action?.payload,
            },
          },
        },
      };
    }
    default:
      return state;
  }
}

export function profileCompletion(
  state: IProfileCompletionState = PROFILE_COMPLETION_INITIAL_STATE,
  action: ProfileCompletionActions
): IProfileCompletionState {
  switch (action.type) {
    case constants.OPEN_RESUME_MODAL: {
      return {
        ...state,
        resumeModalState: {
          currentStep: UploadResumeSteps.uploadFile,
          opened: true,
        },
      };
    }
    case constants.CLOSE_RESUME_MODAL: {
      return {
        ...state,
        error: '',
        isFetchingData: false,
        profileCompletion: {
          analysisStatus: AnalizedResumeStatus.idle,
          analized: {
            workExperiences: [],
            skills: [],
            degreesAndCertifications: [],
          },
          selected: [],
          unnormSkills: [],
        },
        resumeModalState: {
          currentStep: UploadResumeSteps.uploadFile,
          opened: false,
        },
      };
    }
    case constants.CHANGE_RESUME_MODAL_STEP: {
      return {
        ...state,
        error: '',
        resumeModalState: {
          ...state.resumeModalState,
          currentStep: action.payload,
        },
      };
    }
    case constants.GET_ANALIZED_RESUME_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_ANALIZED_RESUME_PARTIALLY_SUCCESS: {
      return {
        ...state,
        profileCompletion: {
          analysisStatus: AnalizedResumeStatus.partial,
          analized: action.payload,
          selected: [],
          unnormSkills: [],
        },
        isFetchingData: false,
      };
    }
    case constants.GET_UNNORMSKILLS_RESUME_PARTIALLY_SUCCESS: {
      return {
        ...state,
        profileCompletion: {
          ...state.profileCompletion,
          unnormSkills: action.payload,
        },
        isFetchingData: false,
      };
    }
    case constants.GET_ANALIZED_RESUME_SUCCESS: {
      return {
        ...state,
        resumeModalState: {
          ...state.resumeModalState,
          currentStep: UploadResumeSteps.selectSections,
        },
        profileCompletion: {
          ...state.profileCompletion,
          analysisStatus: AnalizedResumeStatus.completed,
          analized: {
            ...state.profileCompletion.analized,
            skills: action.payload,
          },
          selected: [],
        },
        isFetchingData: false,
      };
    }
    case constants.GET_ANALIZED_RESUME_FAILED: {
      return {
        ...state,
        error: action.payload ?? i18n.t('failToLoadProfileResume'),
        profileCompletion: {
          ...state.profileCompletion,
          analysisStatus: AnalizedResumeStatus.completed,
        },
        isFetchingData: false,
      };
    }
    case constants.SAVE_RESUME_DATA_FAILED: {
      return {
        ...state,
        error: action.payload,
        isFetchingData: false,
      };
    }
    case constants.SELECT_RESUME_SECTIONS: {
      return {
        ...state,
        profileCompletion: {
          ...state.profileCompletion,
          selected: action.payload,
        },
      };
    }
    default:
      return state;
  }
}

export function recommendedVideo(
  state: IVideoState = RECOMMENDED_VIDEO_INITIAL_STATE,
  action: RecommendedVideoActions
): IVideoState {
  switch (action.type) {
    case constants.GET_RECOMMENDED_VIDEO_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_RECOMMENDED_VIDEO_SUCCESS: {
      return {
        ...state,
        video: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_RECOMMENDED_VIDEO_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadRecommendedVideo'),
        isFetchingData: false,
      };
    }
    default:
      return state;
  }
}

export function manageSkills(
  state: IManageSkillsState = MANAGE_SKILLS_INITIAL_STATE,
  action: ManageSkillsActions
): IManageSkillsState {
  switch (action.type) {
    case constants.GET_SUGGESTED_SKILLS_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_SUGGESTED_SKILLS_SUCCESS: {
      return {
        ...state,
        suggestedSkills: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_SUGGESTED_SKILLS_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadSuggestedSkills'),
        isFetchingData: false,
      };
    }
    case constants.SAVE_SELECTED_SKILLS_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_SELECTED_SKILLS_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_SELECTED_SKILLS_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveSelectedSkills'),
        isFetchingData: false,
      };
    }
    case constants.SEARCH_SKILLS_STARTED: {
      return {
        ...state,
        isFetchingOperation: true,
      };
    }
    case constants.SEARCH_SKILLS_SUCCESS: {
      return {
        ...state,
        foundSkills: action.payload,
        isFetchingOperation: false,
      };
    }
    case constants.SEARCH_SKILLS_FAILED: {
      return {
        ...state,
        foundSkills: [],
        error: i18n.t('failToSearchSkills'),
        isFetchingOperation: false,
      };
    }
    default:
      return state;
  }
}

export function manageCompetencies(
  state: IManageCompetenciesState = MANAGE_COMPETENCIES_INITIAL_STATE,
  action: ManageCompetenciesActions
): IManageCompetenciesState {
  switch (action.type) {
    case constants.GET_SUGGESTED_COMPETENCIES_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_SUGGESTED_COMPETENCIES_SUCCESS: {
      return {
        ...state,
        suggestedCompetencies: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_SUGGESTED_COMPETENCIES_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadSuggestedCompetencies'),
        isFetchingData: false,
      };
    }
    case constants.SAVE_SELECTED_COMPETENCIES_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_SELECTED_COMPETENCIES_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_SELECTED_COMPETENCIES_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveCompetencies'),
        isFetchingData: false,
      };
    }
    case constants.GET_ALL_COMPETENCIES_STARTED: {
      return {
        ...state,
        isFetchingAllData: true,
      };
    }
    case constants.GET_ALL_COMPETENCIES_SUCCESS: {
      return {
        ...state,
        allCompetencies: action.payload,
        isFetchingAllData: false,
      };
    }
    default:
      return state;
  }
}

export function careerPreferences(
  state: ICareerPreferencesState = CAREER_PREFERENCES_INITIAL_STATE,
  action: CareerPreferenceActions
): ICareerPreferencesState {
  switch (action.type) {
    case constants.OPEN_CAREER_MODAL: {
      return {
        ...state,
        careerModalState: {
          opened: true,
        },
      };
    }
    case constants.CLOSE_CAREER_MODAL: {
      return {
        ...state,
        error: '',
        isFetchingData: false,
        careerModalState: {
          opened: false,
        },
      };
    }
    case constants.SAVE_OPEN_TO_WORK: {
      return {
        ...state,
        openToWorkToggle: action.payload,
      };
    }
    case constants.SAVE_OPEN_TO_WORK_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_OPEN_TO_WORK_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_OPEN_TO_WORK_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveCareerPreferences'),
        isFetchingData: false,
      };
    }
    case constants.SAVE_OPEN_TO_WORK_REMOTE_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_OPEN_TO_WORK_REMOTE_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_OPEN_TO_WORK_REMOTE_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveCareerPreferences'),
        isFetchingData: false,
      };
    }
    case constants.SAVE_LOCATIONS_INTERESTED_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_LOCATIONS_INTERESTED_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_LOCATIONS_INTERESTED_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveCareerPreferences'),
        isFetchingData: false,
      };
    }
    case constants.GET_LOCATIONS_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_LOCATIONS_SUCCESS: {
      return {
        ...state,
        locations: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_LOCATIONS_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadLocations'),
        isFetchingData: false,
      };
    }
    default:
      return state;
  }
}

export function workHistory(
  state: IWorkHistoryState = WORK_HISTORY_INITIAL_STATE,
  action: WorkHistoryActions
): IWorkHistoryState {
  switch (action.type) {
    case constants.SAVE_WORK_HISTORY_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_WORK_HISTORY_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_WORK_HISTORY_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveWorkHistory'),
        isFetchingData: false,
      };
    }
    case constants.UPDATE_WORK_HISTORY_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.UPDATE_WORK_HISTORY_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.UPDATE_WORK_HISTORY_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveWorkHistory'),
        isFetchingData: false,
      };
    }
    case constants.REMOVE_WORK_HISTORY_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.REMOVE_WORK_HISTORY_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.REMOVE_WORK_HISTORY_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveWorkHistory'),
        isFetchingData: false,
      };
    }
    case constants.OPEN_WORK_HISTORY_MODAL: {
      return {
        ...state,
        workHistoryModalState: {
          opened: true,
        },
      };
    }
    case constants.CLOSE_WORK_HISTORY_MODAL: {
      return {
        ...state,
        error: '',
        isFetchingData: false,
        workHistoryModalState: {
          opened: false,
        },
      };
    }
    default:
      return state;
  }
}

export function education(
  state: IEducationState = EDUCATION_INITIAL_STATE,
  action: EducationActions
): IEducationState {
  switch (action.type) {
    case constants.SAVE_EDUCATION_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.SAVE_EDUCATION_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.SAVE_EDUCATION_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveDegreesAndCertifications'),
        isFetchingData: false,
      };
    }
    case constants.UPDATE_EDUCATION_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.UPDATE_EDUCATION_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.UPDATE_EDUCATION_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveWorkHistory'),
        isFetchingData: false,
      };
    }
    case constants.REMOVE_EDUCATION_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.REMOVE_EDUCATION_SUCCESS: {
      return {
        ...state,
        isFetchingData: false,
      };
    }
    case constants.REMOVE_EDUCATION_FAILED: {
      return {
        ...state,
        error: i18n.t('failToSaveWorkHistory'),
        isFetchingData: false,
      };
    }
    case constants.OPEN_EDUCATION_MODAL: {
      return {
        ...state,
        educationModalState: {
          opened: true,
        },
      };
    }
    case constants.CLOSE_EDUCATION_MODAL: {
      return {
        ...state,
        error: '',
        isFetchingData: false,
        educationModalState: {
          opened: false,
        },
      };
    }
    default:
      return state;
  }
}

export function successProfileTopCategories(
  state: ISuccessProfileTopCategoriesState = SUCCESS_PROFILE_TOP_CATEGORIES_INITIAL_STATE,
  action: SuccessProfileTopCategoriesActions
): ISuccessProfileTopCategoriesState {
  switch (action.type) {
    case constants.GET_SUCCESS_PROFILE_TOP_CATEGORIES_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_SUCCESS_PROFILE_TOP_CATEGORIES_SUCCESS: {
      return {
        ...state,
        topCategories: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_SUCCESS_PROFILE_TOP_CATEGORIES_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadSuccessProfile'),
        isFetchingData: false,
      };
    }
    default:
      return state;
  }
}

export function successProfile(
  state: ISuccessProfileState = SUCCESS_PROFILE_INITIAL_STATE,
  action: SuccessProfileActions
): ISuccessProfileState {
  switch (action.type) {
    case constants.GET_SUCCESS_PROFILE_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_SUCCESS_PROFILE_SUCCESS: {
      return {
        ...state,
        successProfile: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_SUCCESS_PROFILE_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadSuccessProfile'),
        isFetchingData: false,
      };
    }
    default:
      return state;
  }
}

export function markedAsReadFields(
  state: IMarkedAsReadFieldsState = MARKED_FIELDS_INITIAL_STATE,
  action: MarkFieldAsReadActions
): IMarkedAsReadFieldsState {
  switch (action.type) {
    case constants.MARK_FIELD_AS_READ_FAILED:
      return {
        ...state,
        isFetchingData: false,
      };
    case constants.MARK_FIELD_AS_READ_STARTED:
      return {
        ...state,
        isFetchingData: true,
      };
    case constants.MARK_FIELD_AS_READ_SUCCESS:
      return {
        ...state,
        store: { ...state.store, [action.payload]: true },
        isFetchingData: false,
      };
    case constants.GET_MARKED_FIELDS_AS_READ_STARTED:
      return {
        ...state,
        isFetchingData: true,
      };
    case constants.GET_MARKED_FIELDS_AS_READ_FAILED:
      return {
        ...state,
        isFetchingData: false,
      };
    case constants.GET_MARKED_FIELDS_AS_READ_SUCCESS:
      return {
        store: action.payload,
        isFetchingData: false,
      };
    default:
      return state;
  }
}

export function onboardEmployeeSkills(
  state: IOnboardEmployeeSkillsState = ONBOARD_EMPLOYEE_SKILLS_INITIAL_STATE
): IOnboardEmployeeSkillsState {
  return {
    ...state,
    waitForNotification: false,
    notificationArrived: true,
  };
}

export function onboardEmployeeRoles(
  state: IOnboardEmployeeRolesState = ONBOARD_EMPLOYEE_ROLES_INITIAL_STATE,
  action: OnboardEmployeeRolesAction
): IOnboardEmployeeRolesState {
  switch (action.type) {
    case constants.ONBOARD_EMPLOYEE_ROLES_STARTED:
      return {
        ...state,
        isUpdatingRoles: true,
        waitForNotification: false,
      };
    case constants.ONBOARD_EMPLOYEE_ROLES_SUCCESS:
      return {
        ...state,
        isUpdatingRoles: false,
        waitForNotification: true,
      };
    case constants.ONBOARD_EMPLOYEE_ROLES_FAILED:
      return {
        ...state,
        isUpdatingRoles: false,
        waitForNotification: false,
      };
    case constants.ONBOARD_EMPLOYEE_ROLES_NOTIFICATION_ARRIVED:
      return {
        ...state,
        waitForNotification: false,
        notificationArrived: true,
      };
    default:
      return state;
  }
}

export function onboardEmployeeOpenToWork(
  state: IOnboardEmployeeOpenToWorkState = ONBOARD_EMPLOYEE_OPEN_TO_WORK_INITIAL_STATE,
  action: OnboardEmployeeOpenToWorkAction
): IOnboardEmployeeOpenToWorkState {
  switch (action.type) {
    case constants.ONBOARD_EMPLOYEE_OPEN_TO_WORK_STARTED:
      return {
        ...state,
        isUpdatingOpenToWork: true,
        waitForNotification: false,
      };
    case constants.ONBOARD_EMPLOYEE_OPEN_TO_WORK_SUCCESS:
      return {
        ...state,
        isUpdatingOpenToWork: false,
        waitForNotification: true,
      };
    case constants.ONBOARD_EMPLOYEE_OPEN_TO_WORK_FAILED:
      return {
        ...state,
        isUpdatingOpenToWork: false,
        waitForNotification: false,
      };
    case constants.ONBOARD_EMPLOYEE_OPEN_TO_WORK_NOTIFICATION_ARRIVED:
      return {
        ...state,
        waitForNotification: false,
        notificationArrived: true,
      };
    default:
      return state;
  }
}
